import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-124f0816"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-section" }
const _hoisted_2 = { class: "modal-section-title" }
const _hoisted_3 = { class: "group-summary" }

import { computed } from 'vue';
import { BaseButton, XrkMessage } from 'xrk-components';
import { formatter } from '@/utils';
import type { CategoryGroups } from '@V/invoice/src/data-source/types';
import IndividualCategoryGroupItem from './individual-category-group-item.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'individual-category-group',
  props: /*#__PURE__*/_mergeModels({
    formData: { default: () => ({}) },
    isConfirm: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  }, {
    "categoryGroups": {
  default: () => [{ itemId: null, itemName: '', settlementList: [] }]
},
    "categoryGroupsModifiers": {},
  }),
  emits: ["update:categoryGroups"],
  setup(__props: any, { expose: __expose }) {



// 分组数据 v-model（增删改回写父级）
const categoryGroups = _useModel<CategoryGroups>(__props, 'categoryGroups');

/** 所有分组已选ID集合（跨组传递给弹窗做排除） */
const allPreSelectedIds = computed(() => {
  const ids = new Set<number>();
  categoryGroups.value.forEach(g => {
    (g.settlementList || []).forEach((item: any) => {
      ids.add(item.settlementUserTaskId);
    });
  });
  return [...ids];
});

const allSelectedItems = computed(() => {
  const seen = new Set<number>();
  const items: any[] = [];
  categoryGroups.value.forEach(g => {
    (g.settlementList || []).forEach((item: any) => {
      if (!seen.has(item.settlementUserTaskId)) {
        seen.add(item.settlementUserTaskId);
        items.push(item);
      }
    });
  });
  return items;
});

const totalTaxPrice = computed(() => {
  return allSelectedItems.value.reduce(
    (sum, item) => sum + (item.terminalSettlementAmount || 0),
    0
  );
});

const maxInvoiceAmount = computed(() => totalTaxPrice.value);

const canAddGroup = computed(() => {
  const last = categoryGroups.value[categoryGroups.value.length - 1];
  return last && last.settlementList?.length > 0;
});

const onGroupDataUpdate = (
  idx: number,
  data: { itemId: number | null; itemName: string; settlementList: any[] }
) => {
  categoryGroups.value[idx] = { ...categoryGroups.value[idx], ...data };
};

const onRemoveGroup = (idx: number) => {
  categoryGroups.value.splice(idx, 1);
};

const onAddGroup = () => {
  categoryGroups.value.push({
    itemId: null,
    itemName: '',
    settlementList: []
  });
};

/* ---------------- 校验（暴露给父组件） ---------------- */
const validate = () => {
  if (
    !categoryGroups.value.length ||
    !categoryGroups.value.every(g => g.settlementList.length)
  ) {
    XrkMessage.error('请至少选择一个类目分组并选择开票数据');
    return Promise.reject(new Error('请至少选择一个类目分组并选择开票数据'));
  }
  return Promise.resolve();
};

__expose({ validate });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(" 开票数据 "),
      (!_ctx.isConfirm)
        ? (_openBlock(), _createBlock(_unref(BaseButton), {
            key: 0,
            type: "text",
            style: {"color":"#e97132"},
            onClick: onAddGroup,
            disabled: !canAddGroup.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(" +新增类目分组 ")
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryGroups.value, (group, idx) => {
      return (_openBlock(), _createBlock(IndividualCategoryGroupItem, {
        key: idx,
        groupIndex: idx,
        formData: _ctx.formData,
        itemId: group.itemId,
        settlementList: group.settlementList,
        globalPreSelectedIds: allPreSelectedIds.value,
        disabled: _ctx.disabled,
        "onUpdate:data": data => onGroupDataUpdate(idx, data),
        onRemove: onRemoveGroup
      }, null, 8, ["groupIndex", "formData", "itemId", "settlementList", "globalPreSelectedIds", "disabled", "onUpdate:data"]))
    }), 128)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, [
        _createTextVNode(" 价税合计： "),
        _createElementVNode("b", null, _toDisplayString(_unref(formatter).fen2yuan(totalTaxPrice.value)), 1),
        _createTextVNode(" 元 ")
      ]),
      _createElementVNode("span", null, [
        _createTextVNode(" 最大开票金额： "),
        _createElementVNode("b", null, _toDisplayString(_unref(formatter).fen2yuan(maxInvoiceAmount.value)), 1),
        _createTextVNode(" 元 ")
      ])
    ])
  ]))
}
}

})